import { filterNullish } from '@modernhealth/filter-nullish';
import { appClient } from 'src/config/apollo';

import {
    GetCompanyAdditionalBenefitsDocument,
    GetCompanyAdditionalBenefitsQuery,
    CompanyAdditionalBenefitFragment,
} from '../documents/getCompanyAdditionalBenefitsQuery.generated';

export class Benefits {
    public async fetchCompanyAdditionalBenefits(): Promise<CompanyAdditionalBenefitFragment[]> {
        const { data } = await appClient.query<GetCompanyAdditionalBenefitsQuery>({
            query: GetCompanyAdditionalBenefitsDocument,
            fetchPolicy: 'network-only',
        });

        return filterNullish(data?.companyAdditionalBenefits ?? []);
    }
}
